module.exports = __webpack_public_path__ + "img/mr.28694aeb.svg";